import type { CSSProperties } from 'react';

/**
 * 抽屉按钮样式
 */
export const drawerButtonStyles: CSSProperties = {
  borderStartStartRadius: 0,
  borderEndStartRadius: 0,
  position: 'fixed',
  top: 64,
  zIndex: 999,
};
